/**
 * Logo slugs that name no brand.
 *
 * A generated e-mail whose scenario names no brand (an internal HR / IT / payroll notice) carries the slug
 * `humanfirewall` (or one of its siblings) on its logo placeholder. The send path never serves a stored brand row
 * for these: the employer's own logo, else the neutral organisation logo (generic-org-logo.ts) — never the
 * HumanFirewall "H" that the logo route would answer with, which would name the platform as the sender. A screen
 * that previews such an e-mail has to draw the same thing, or it shows the person something that will not be sent.
 *
 * A copy of the API's `GENERIC_BRAND_SLUGS` (apps/api/src/common/channels/brand-logo.service.ts), which decides this
 * on the send path; `lib/brand-logos/__tests__/generic-logo-slugs-parity.guard.spec.ts` fails when the two differ.
 */
export const GENERIC_LOGO_SLUGS: ReadonlySet<string> = new Set(['humanfirewall', 'your-it-team', 'it-team', 'generic'])

/** True when `slug` is one of the generic slugs (case and surrounding space do not matter). */
export function isGenericLogoSlug(slug: string | null | undefined): boolean {
  return typeof slug === 'string' && GENERIC_LOGO_SLUGS.has(slug.trim().toLowerCase())
}
